import { defineMessage } from 'react-intl';
import type { DateSelectorPresetId } from './date-selector-presets';

/**
 * Message descriptors for date selector preset labels.
 * The 5 "more days" (dayMinus2..dayMinus6) are formatted via formatShortDateInTimezone, not messages.
 */
export const dateSelectorPresetMessages: Record<
  DateSelectorPresetId,
  ReturnType<typeof defineMessage>
> = {
  today: defineMessage({
    id: 'common.dateSelector.preset.today',
    defaultMessage: 'Hoy',
  }),
  yesterday: defineMessage({
    id: 'common.dateSelector.preset.yesterday',
    defaultMessage: 'Ayer',
  }),
  dayMinus2: defineMessage({
    id: 'common.dateSelector.preset.dayMinus2',
    defaultMessage: '', // Rendered as short date in component
  }),
  dayMinus3: defineMessage({
    id: 'common.dateSelector.preset.dayMinus3',
    defaultMessage: '',
  }),
  dayMinus4: defineMessage({
    id: 'common.dateSelector.preset.dayMinus4',
    defaultMessage: '',
  }),
  dayMinus5: defineMessage({
    id: 'common.dateSelector.preset.dayMinus5',
    defaultMessage: '',
  }),
  dayMinus6: defineMessage({
    id: 'common.dateSelector.preset.dayMinus6',
    defaultMessage: '',
  }),
  selectDate: defineMessage({
    id: 'common.dateSelector.selectDate',
    defaultMessage: 'Seleccionar fecha',
  }),
};
